module.exports = __webpack_public_path__ + "static/media/bw.5f11a0be.svg";